import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-mobile-footer',
  templateUrl: './mobile-footer.component.html',
  styleUrls: ['./mobile-footer.component.scss'],
  standalone: false,
})
export class MobileFooterComponent {
  @Output()
  public readonly back = new EventEmitter<void>();

  constructor() {}
}
